<template>
  <div>
    <b-button
      v-if="canUserEdit"
      class="mt-2"
      name="saveStrucuture"
      variant="success"
      @click="trySubmit()"
    >
      Speichern
    </b-button>
    <b-button
      v-if="canUserEdit"
      class="mt-2 ml-2"
      name="loadStructure"
      variant="danger"
      @click="cancel"
    >
      Abbrechen
    </b-button>
    <b-modal
      id="confirmSaveGroupedPlz"
      ref="confirmSaveGroupedPlz"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Eingabekriterium löschen"
    >
      <div class="d-block mb-4">
        Einige PLZ wurden noch nicht angewählt. Möchten Sie trotzdem speichern?
        Folgende PLZ wurden nicht angewählt:
      </div>
      <b-alert
        show
        variant="warning"
      >
        <div
          v-for="(plz, plzIndex) in missingPlzs"
          :key="plzIndex"
        >
          <span>{{ plz.displayText }}</span>
        </div>
      </b-alert>

      <b-button
        variant="success"
        @click="confirm()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="cancel()"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { CheckMissingPLZForGroupedPlz } from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  name: "CriteriaGroupedPlzSubmit",
  mixins: [MinimumWageMixin],
  props: {
    disableSave: {
      type: Boolean,
      default: false,
    },
    criteria: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Your component's data goes here
      missingPlzs: [],
    };
  },
  methods: {
    // Your component's methods go here
    trySubmit() {
      CheckMissingPLZForGroupedPlz(
        this.contractId,
        this.versionId,
        this.$store.state.mindestLohnKonfiguration.Configuration.id,
        this.criteria,
        "de-CH",
        (response) => {
          this.missingPlzs = response;
          if (this.missingPlzs.length > 0) {
            this.showModal("confirmSaveGroupedPlz");
          } else {
            this.$emit("confirm");
          }
        },
        (error) => {
          this.error(error);
        },
      );
    },
    error(error) {
      this.$emit("error", error);
    },
    confirm() {
      this.hideModal("confirmSaveGroupedPlz");
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  },
};
</script>

<style scoped>
/* Your component's styles go here */
</style>
